import React, {FC, PropsWithChildren} from 'react';

import {Icon} from '../../../../libs/shared/ui/src/components/icon/icon';
import {styled, useUserTheme} from '../../../../libs/shared/ui/src/theme/userThemeProvider';

/*
 * Props.
 */

interface DropdownItemNestedIconProps {
  nestingLevel: number;
}

/*
 * Style.
 */

interface NestingOffsetStyleProps {
  $nestingLevel: number;
}

const StyledNestingOffsetDiv = styled.div<NestingOffsetStyleProps>`
  grid-area: left-icon;

  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: 1fr;
  grid-column-gap: 7px;

  justify-items: center;
  align-items: center;

  margin-right: 8px;
  padding-left: ${(p) => Math.min(3, Math.max(p.$nestingLevel - 1, 0)) * 26}px;
`;

/*
 * Component.
 */

export const DropdownItemNestedIcon: FC<PropsWithChildren<DropdownItemNestedIconProps>> = ({
  nestingLevel,
  children,
}) => {
  const theme = useUserTheme();

  return (
    <StyledNestingOffsetDiv $nestingLevel={nestingLevel}>
      {nestingLevel > 0 && <Icon name="arrowNestedSmall" color={theme.greys.shade60} />}
      {children}
    </StyledNestingOffsetDiv>
  );
};
